export default "__VITE_ASSET__178c9205__"